import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2715ed8c&"
import script from "./Home.ts?vue&type=script&lang=js&"
export * from "./Home.ts?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=2715ed8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports